
<h3 mat-dialog-title>This will be Changed to Pending Vaccine</h3>

<br>
<div class="float-right">
   <span><button class="btn btn-danger" (click)="pendingyes('no')">No</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<button class="btn btn-primary" (click)="pendingyes('yes')">Yes</button></span>
</div>


